import InternalList from './List';
import Item from './Item';

type InternalListType = typeof InternalList;

interface ListProps extends InternalListType {
  Item: typeof Item;
}

const List = InternalList as ListProps;

List.Item = Item;

export default List;
